import { Component, OnInit } from '@angular/core';
declare var $: any

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    //$("#example2").DataTable();
    $('#example2 td').click(function (event: any) {
      // var href = $(this).find("a").attr("href");
      // if(href) {
      //     window.location = href;
      // }
      if(event.target.className != "col-checked"){
        $("#detailModal").modal('show')
      }
    });
  }

  clearActionActive() {
    $(".action-menu").each(function () {
      $(this).removeClass("active")
    })
  }

  CloseModal(modalId: string) {
    $("#" + modalId).modal("hide")
    this.clearActionActive()
  }

  newContact(event: any) {
    this.clearActionActive()
    event.target.classList.add("active")

    $("#exampleModal").modal('show')
  }
  delete(event: any) {
    this.clearActionActive()
    event.target.classList.add("active")
  }
  merge(event: any) {
    this.clearActionActive()
    event.target.classList.add("active")
    $("#mergeModal").modal('show')
  }
  sms(event: any) {
    this.clearActionActive()
    event.target.classList.add("active")
    $("#smsModal").modal('show')
  }
  email(event: any) {
    this.clearActionActive()
    event.target.classList.add("active")
    $("#emailModal").modal('show')
  }

  confirmMerge() {
    $("#mergeModal").modal('hide')
  }

  confirmSMS() {
    $("#smsModal").modal('hide')
  }

  confirmEmail() {
    $("#emailModal").modal('hide')
  }

}



// WEBPACK FOOTER //
// ./src/app/contact/contact.component.ts